module.exports = __webpack_public_path__ + "static/media/display-suite-19.720a4b9a.jpg";